export default __webpack_public_path__ + "static/media/lotus.c29c1e6a.svg";